import { actionTypeVentilstillinger } from "../actions/ventilstillingerActions";
import { CreateNewReducer } from "../utils/reducerUtils";

const initialState = [];
const ventilstillingerReducer = (state = initialState, action) =>
  CreateNewReducer(state, action, actionTypeVentilstillinger);

export default ventilstillingerReducer;
